import React from "react";

const CardBack = (props) => {
  return (
    <div className="back">
      <h1 className="course-title">{props.title}</h1>
      <div className="course-tutors">
        Instructors:{" "}
        <span className="course-tutors-name">{props.instructor}</span>
      </div>
    </div>
  );
};

export default CardBack;
